import React from 'react';
import { Button, Icon, Table, Form, Header, Segment, Popup, Loader, Input, Divider } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';

import { IconHeader, FiltersOnStyle } from '../../../Professor/ProfessorInputGrades/css';
import StudyProgramsFilter from '../../StudentEnroll/StudyProgramsFilter';
import { FormattedMessage } from 'react-intl';
import { fetchAcademicYears, fetchAllAcademicYears } from '../../../Lookups/util';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class CourseEnrollment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            semesterOptions: []
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.fetchCourseOptions = this.fetchCourseOptions.bind(this);
        this.fetchAcademicYearOptions = this.fetchAcademicYearOptions.bind(this);
        this.fetchSemesterNumOptions = this.fetchSemesterNumOptions.bind(this);
        this.fetchSemesterOptions = this.fetchSemesterOptions.bind(this);
        this.fetchCourseImplementationOptions = this.fetchCourseImplementationOptions.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.enrollStudent = this.enrollStudent.bind(this);
    }

    componentDidMount() {
        this.props.fetchStudentOptions();
        this.fetchAcademicYearOptions();
    }

    fetchCourseOptions(id) {
        axios.get(`/course/not-passed-and-not-enrolled/${id}/`)
            .then(res => {
                this.setState({
                    courseOptions: res.data.map(el => ({
                        ...el, key: el.id, value: { id: el.id, courseBasicId: el.courseBasicId }, text: el.courseBasicName + (el.code ? ' | ' + el.code : ''), description: el.comment ? el.courseBasicComment ? el.comment + ' | ' + el.courseBasicComment : el.comment : el.courseBasicComment ? el.courseBasicComment : ''
                    }))
                });
            });
    }
    fetchSemesterNumOptions(id) {
        axios.get(`/study-programs/courses/semesters/${id}/`)
            .then(res => {
                this.setState({
                    semesterNumOptions: res.data.map(el => ({
                        ...el, key: el.studyProgramSemester.id, value: el.studyProgramSemester.id, text: el.studyProgramSemester.name
                    }))
                });
            });
    }
    fetchAcademicYearOptions() {
        // If early enrollment for the next academic year is currently open (semester/enrollment/ already
        // returns semesters from that year, ahead of the current one), offer all academic years; otherwise
        // only current + previous.
        axios.all([axios.get('semester/enrollment/'), axios.get('academic-years/current')])
            .then(axios.spread((currentSemRes, currentAcademicYearRes) => {
                const earlyEnrollmentOpen = currentSemRes.data.some(el => el.academicYear.id !== currentAcademicYearRes.data.id);

                (earlyEnrollmentOpen ? fetchAllAcademicYears() : fetchAcademicYears())
                    .then(res => {
                        this.setState({
                            academicYearOptions: res.data.reverse().map(el => ({
                                ...el, key: el.id, value: el.id, text: el.name
                            }))
                        });
                    });
            }));
    }

    fetchSemesterOptions(academicYearId) {
        axios.get(`semester/by-academic-year/${academicYearId}`)
            .then(res => {
                this.setState({
                    semesterOptions: res.data.map(el => ({
                        ...el, key: el.id, value: el.id, text: el.name.name
                    }))
                });
            });
    }
    fetchCourseImplementationOptions(courseId, semesterId) {
        let obj = {
            id: courseId
        };
        axios.post(`/course/implementations/by-ou-and-semester/${semesterId}/`, { ...obj })
            .then(res => {
                this.setState({
                    courseImplementationOptions: res.data.map(el => ({
                        ...el,
                        key: el.id,
                        value: el.id,
                        text: el.courseBasic.name ?
                            el.courseBasic.name + (el.code ? ' | ' + el.code : '') + (el.comment ? ' | ' + el.comment : '')
                            : (el.code ? ' | ' + el.code : '') + (el.comment ? ' | ' + el.comment : '')
                    }))
                });
            });
    }

    resetForm() {
        this.setState({

            semesterNum: null,
            course: null,
            academicYear: null,
            semester: null,
            courseImplementation: null
        });
    }

    enrollStudent() {
        if (!this.state.student || !this.state.semester || !this.state.semesterNum || !this.state.academicYear || !this.state.courseImplementation || !this.state.course) {
            toast(<FormattedMessage id="common.requiredFields" />);
            if (!this.state.student) { this.setState({ studentErr: true }); } else { this.setState({ studentErr: false }); }
            if (!this.state.semester) { this.setState({ semesterErr: true }); } else { this.setState({ semesterErr: false }); }
            if (!this.state.semesterNum) { this.setState({ semesterNumErr: true }); } else { this.setState({ semesterNumErr: false }); }
            if (!this.state.course) { this.setState({ courseErr: true }); } else { this.setState({ courseErr: false }); }
            if (!this.state.academicYear) { this.setState({ academicYearErr: true }); } else { this.setState({ academicYearErr: false }); }
            if (!this.state.courseImplementation) { this.setState({ courseImplementationErr: true }); } else { this.setState({ courseImplementationErr: false }); }
        } else {
            this.setState({ loader: true });
            let obj = {
                studentStudyProgram: {
                    id: this.state.student.id
                },
                courseImplementation: {
                    id: this.state.courseImplementation
                }
            };

            axios.post(`/course/implementation-enrollment/${this.state.semester}/${this.state.semesterNum}/true/`, { ...obj })
                .then(res => {
                    this.setState({ loader: false });

                    this.resetForm();
                    toast('Uspješno ste upisali studenta na predmet!');
                })
                .catch(err => {
                    this.setState({ loader: false });
                    if (err.response.data === 'Student is already enrolled in this course implementation!') { toast('Student je već upisan na ovu implementaciju!'); } else
                    if (err.response.data === 'Student is enrolled in this semester more than once!') { toast('Student je više puta upisan u semestar!'); } else
                    if (err.response.data === 'Student is not enrolled in this semester!') { toast('Student nije upisan u semestar!'); } else { toast('Došlo je do greške. Student nije upisan na predmet!'); }
                });
        }
    }

    handleInputChange(event, { name, value }) {
        if (name === 'student') { this.fetchCourseOptions(value.id); }
        if (name === 'course') { this.fetchSemesterNumOptions(value.id); if (this.state.semester) this.fetchCourseImplementationOptions(value.courseBasicId, this.state.semester); }
        if (name === 'academicYear') { this.fetchSemesterOptions(value); }
        if (name === 'semester' && this.state.course) { this.fetchCourseImplementationOptions(this.state.course.courseBasicId, value); }

        this.setState({
            [name]: value
        });
    }

    render() {
        return (
            <div>


                <Loader active={this.state.loader} />
                {/* <Divider horizontal> */}
                {/*    <Header as='h4'> */}
                {/*       Podaci o upisu */}
                {/*    </Header> */}
                {/* </Divider> */}

                <Form>
                    <Form.Group widths="equal">
                        <Form.Field required error={this.state.studentErr}>
                            <label>Student</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odabir studenta"
                                value={this.state.student}
                                onChange={this.handleInputChange}
                                name="student"
                                options={this.props.studentOptions}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field required error={this.state.courseErr}>
                            <label>Predmet </label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odabir predmeta"
                                value={this.state.course}
                                onChange={this.handleInputChange}
                                name="course"
                                options={this.state.courseOptions}
                                search
                                disabled={!this.state.student}
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field required error={this.state.semesterNumErr}>
                            <label>Semestar (u kojem je prvi put slušan predmet)</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odabir semestra"
                                value={this.state.semesterNum}
                                onChange={this.handleInputChange}
                                name="semesterNum"
                                options={this.state.semesterNumOptions}
                                search
                                disabled={!this.state.course}
                                fluid
                                selection
                            />
                        </Form.Field>


                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Field required error={this.state.academicYearErr}>
                            <label>Akademska godina</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odabir godine"
                                value={this.state.academicYear}
                                onChange={this.handleInputChange}
                                name="academicYear"
                                options={this.state.academicYearOptions}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field required error={this.state.semesterErr}>
                            <label>Semestar</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odabir semestra"
                                value={this.state.semester}
                                onChange={this.handleInputChange}
                                name="semester"
                                options={this.state.semesterOptions.filter(e => e.name._key !== 'other' && e.name._key !== 'summer school')}
                                search
                                disabled={!this.state.academicYear}
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field required error={this.state.courseImplementationErr}>
                            <label>Implementacija predmeta </label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odabir implementacije"
                                value={this.state.courseImplementation}
                                onChange={this.handleInputChange}
                                name="courseImplementation"
                                disabled={!this.state.course || !this.state.semester}
                                options={this.state.courseImplementationOptions}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>


                    </Form.Group>
                    <Button
                        floated="right"
                        color="blue"
                        onClick={() => {
                            this.enrollStudent();
                        }}
                    >Upiši studenta </Button>
                    <br />
                    <br />
                </Form>

                <ToastContainer hideProgressBar />

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ThirdCycle/CourseEnrollment/CourseEnrollment.js